<div class="product-graph-widget">
	<app-loader [showLoader]="showLoad"></app-loader>
	<div class="product-overview" [ngClass]="{ disableDiv: applyNodata }">
		<app-days-filter-r10
			[daysButton]="daysButton"
			[weeksButton]="weeksButton"
			[monthsButton]="monthsButton"
			[applyNodata]="applyNodata"
			(buttonEventUpdate)="updateChartData($event)"
		></app-days-filter-r10>
		<div style="height: 300px;">
			<app-generic-chart *ngIf="chartData?.length" [configuration]="chartConfig" [data]="chartData"></app-generic-chart>
		</div>
	</div>
</div>
